import { vuex as app } from '../app'
// create a new object and preserv original keys
export default [...app.plugins]



// WEBPACK FOOTER //
// ./src/store/plugins.js